import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import TipoAndamentoProcessualService from '../../app/service/TipoAndamentoProcessualService'

class TipoAndamentoProcessual extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: null,
      tipos: [],
      codigo: '',
      nome: '',
      modalTipo: null,
      modalTipoAlterar: null,
      openSpinner: false
    }

    this.tipoAndamentoProcessualService = new TipoAndamentoProcessualService();

    this.renderFooterCadastroTipos = this.renderFooterCadastroTipos.bind(this);
    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterAlterarTipos = this.renderFooterAlterarTipos.bind(this);
  }

  renderFooterCadastroTipos(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTipo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  cadastrarTipo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipo de Andamanto Processual', detail:'A descrição do Tipo de Andamento é obrigatório', life: 4000});
      return;
    }

    const tipo = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.tipoAndamentoProcessualService.cadastrar(tipo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipo de Andamanto Processual', detail:'Tipo cadastrado com sucesso', life: 4000});
        this.listar();
        this.fecharModal('modalTipo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Andamanto Processual', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listar = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoAndamentoProcessualService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tipos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Andamanto Processual', detail:`${this.state.detail}`, life: 4000});
      });
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterAlterarTipos(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTipo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  alterarTipo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipo de Andamanto Processual', detail:'A descrição do Tipo de Andamento é obrigatório', life: 4000});
      return;
    }

    const tipo = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.tipoAndamentoProcessualService.alterar(tipo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipo de Andamanto Processual', detail:'Tipo de Andamento Processual excluído', life: 4000});
        this.listar();
        this.fecharModal('modalTipoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Andamanto Processual', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTipo(rowData)}
                tooltip="Editar Tipo de Andamento Processual" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Tipo de Andamento Processual" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  async consultarTipo(tipo) {
    this.setState({openSpinner: true});
    this.tipoAndamentoProcessualService.consultar(tipo.codigo)
      .then(response => {
        this.setState({tipo: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.abrirModaAlterar('modalTipoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Andamanto Processual', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  confirmaExclusao(tipo) {
    this.setState({codigo: tipo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o tipo de andamento processual selecionado?',
        header: 'Exclusão de Tipo de Andamento Processual',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirTipo() {
    this.setState({openSpinner: true});
    this.tipoAndamentoProcessualService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipo de Andamanto Processual', detail:'Tipo de Andamanto Processual excluído com sucesso', life: 4000});
        this.listar();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Andamanto Processual', detail:`${this.state.detail}`, life: 4000});
      });
      
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirTipo();
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({tipo: null});
    this.setState({nome: ''});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listar();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Tipos */}
          <Dialog header="Cadastro de Tipos de Andamento Processual"
                    visible={this.state.modalTipo} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroTipos('modalTipo')} 
                    onHide={() => this.fecharModal('modalTipo')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTipo">Nome</label>
                        <InputText id="nomeTipo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Tipo de Andamento */}
          <Dialog header="Alterar Tipo de Andamento Processual"
                    visible={this.state.modalTipoAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarTipos('modalTipoAlterar')} 
                    onHide={() => this.fecharModal('modalTipoAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTipoAlterar">Nome</label>
                        <InputText id="nomeTipoAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-list"></i>
                        <span> Tipos de Andamanto Processual</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalTipo')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.tipos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      emptyMessage=" "
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}
TipoAndamentoProcessual.contextType = AuthContext;
export default withRouter (TipoAndamentoProcessual)